import { Card } from '@/components/ui/card';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { HelpCircle, MessageCircle } from 'lucide-react';

export default function FAQ() {
  const faqs = [
    {
      category: 'Umum',
      questions: [
        {
          q: 'Apa saja layanan yang ditawarkan Arnata?',
          a: 'Arnata menyediakan layanan web development (frontend, backend, DevOps), IoT development & integration, troubleshooting & maintenance, engineering support (MATLAB, AutoCAD, Fusion, PCB design), dan digital products (e-book, course, template).'
        },
        {
          q: 'Siapa yang bisa menggunakan layanan Arnata?',
          a: 'Layanan kami terbuka untuk mahasiswa teknik/IT, UMKM, startup kecil, personal brand, komunitas/organisasi kampus, dan siapa saja yang membutuhkan solusi teknologi atau konsultasi teknis.'
        },
        {
          q: 'Bagaimana cara memulai project dengan Arnata?',
          a: 'Sangat mudah! Hubungi kami via WhatsApp atau form kontak, ceritakan kebutuhan Anda, dan kami akan diskusikan scope, timeline, dan estimasi biaya. Konsultasi awal gratis!'
        }
      ]
    },
    {
      category: 'Project & Timeline',
      questions: [
        {
          q: 'Berapa lama rata-rata pengerjaan project?',
          a: 'Timeline bervariasi tergantung kompleksitas:\n• Landing page: 2-5 hari\n• Company profile: 1-2 minggu\n• Dashboard/Web app: 1-2 minggu\n• IoT system: 1-2 minggu\n• Troubleshooting: 1-7 hari\n\nTimeline pasti akan didiskusikan saat konsultasi awal.'
        },
        {
          q: 'Apakah bisa urgent project dengan deadline ketat?',
          a: 'Bisa, dengan catatan scope project memungkinkan dan ada additional cost untuk rush order. Diskusikan kebutuhan urgent Anda saat konsultasi.'
        },
        {
          q: 'Bagaimana alur kerja dari kontak pertama sampai project selesai?',
          a: '1) Konsultasi awal: diskusi kebutuhan & tujuan\n2) Skema: estimasi waktu, biaya, dan teknologi\n3) Eksekusi: development dengan regular updates\n4) Testing & revisi: quality check dan adjustment\n5) Handover: dokumentasi lengkap & support lanjutan'
        }
      ]
    },
    {
      category: 'Biaya & Pembayaran',
      questions: [
        {
          q: 'Berapa biaya layanan Arnata?',
          a: 'Biaya bervariasi tergantung scope dan kompleksitas project. Kami flexible dengan budget mahasiswa dan UMKM. Request quote gratis via WhatsApp atau form kontak dengan ceritakan detail project Anda.'
        },
        {
          q: 'Apakah bisa sistem pembayaran bertahap?',
          a: 'Ya! Untuk project besar kami menyediakan sistem cicilan:\n• DP 30-50% saat agreement\n• Progress payment 30% saat development milestone\n• Pelunasan 20-40% saat handover\n\nSistem pembayaran akan disesuaikan dengan kesepakatan.'
        },
        {
          q: 'Apa yang termasuk dalam biaya project?',
          a: 'Biaya project mencakup:\n• Development (frontend, backend, integration)\n• Testing & debugging\n• Dokumentasi teknis\n• Support 1-2 minggu setelah handover\n• Minor revisions (sesuai kesepakatan)\n\nBiaya hosting, domain, dan third-party services umumnya ditanggung client.'
        }
      ]
    },
    {
      category: 'Teknis',
      questions: [
        {
          q: 'Teknologi apa saja yang digunakan?',
          a: 'Web: React, Next.js, Vue.js, Node.js, Express, FastAPI, PostgreSQL, MongoDB\nIoT: ESP32/ESP8266, Arduino, MQTT, sensor integration\nDevOps: Docker, AWS, DigitalOcean, Nginx, PM2, CI/CD\nTools: MATLAB, AutoCAD, Fusion 360, KiCAD, PCB design software'
        },
        {
          q: 'Apakah hasil project bisa di-deploy ke hosting saya sendiri?',
          a: 'Tentu! Kami bisa deploy ke hosting yang Anda sediakan (shared hosting, VPS, cloud) atau kami bantu rekomendasikan dan setup hosting sesuai kebutuhan. Dokumentasi deployment juga disediakan.'
        },
        {
          q: 'Apakah saya mendapatkan source code?',
          a: 'Ya, full source code menjadi milik Anda setelah pelunasan. Kami juga provide dokumentasi untuk memudahkan maintenance atau development lanjutan oleh tim Anda.'
        }
      ]
    },
    {
      category: 'Engineering Support & Mentoring',
      questions: [
        {
          q: 'Apakah layanan mentoring ini mengerjakan tugas/skripsi saya?',
          a: 'TIDAK. Layanan engineering support kami berupa bimbingan, konsultasi, review, dan mentoring, bukan jasa mengerjakan tugas/skripsi/ujian secara penuh. Kami bantu Anda memahami konsep, arsitektur, debugging, dan best practices agar Anda bisa menyelesaikan project secara etis dan mandiri.'
        },
        {
          q: 'Apa yang termasuk dalam engineering support?',
          a: 'Engineering support mencakup:\n• Review konsep dan arsitektur sistem\n• Guidance pemilihan hardware/software\n• Code review dan debugging assistance\n• Penjelasan MATLAB, AutoCAD, Fusion concepts\n• Review desain skematik dan PCB layout\n• Tips & best practices engineering\n\nTujuannya membantu Anda belajar dan menyelesaikan sendiri.'
        },
        {
          q: 'Berapa lama sesi mentoring?',
          a: 'Sesi mentoring flexible, bisa per-session (1-2 jam). Format bisa online (video call, chat) atau offline (jika lokasi memungkinkan). Jadwal disesuaikan dengan ketersediaan kedua pihak.'
        }
      ]
    },
    {
      category: 'Support & Maintenance',
      questions: [
        {
          q: 'Apakah ada garansi atau support setelah project selesai?',
          a: 'Ya! Kami provide:\n• Bug fix gratis 1-2 minggu setelah handover\n• Technical support via chat untuk troubleshooting dasar\n• Dokumentasi lengkap untuk maintenance\n\nUntuk support jangka panjang atau feature addition, bisa diskusikan paket maintenance terpisah.'
        },
        {
          q: 'Bagaimana jika ada bug setelah masa support berakhir?',
          a: 'Anda bisa request troubleshooting service dengan sistem per-case atau jasa maintenance. Kami akan analisa issue, estimasi effort, dan provide solution dengan transparent pricing.'
        },
        {
          q: 'Apakah bisa menambah fitur setelah project selesai?',
          a: 'Absolutely! Feature addition bisa dilakukan kapan saja. Cukup contact kami dengan detail fitur yang diinginkan, kami akan provide estimasi waktu dan biaya untuk development lanjutan.'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="faq-page">
      {/* Hero */}
      <section className="pt-32 pb-20 px-6 noise-overlay">
        <div className="container mx-auto text-center">
          <HelpCircle size={64} className="text-cyan-400 mx-auto mb-6" />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }} data-testid="faq-title">
            Frequently Asked
            <br />
            <span className="gradient-text">Questions</span>
          </h1>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            Temukan jawaban untuk pertanyaan umum tentang layanan, project, biaya, dan proses kerja kami.
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="space-y-8">
            {faqs.map((category, catIndex) => (
              <div key={catIndex} data-testid={`faq-category-${catIndex}`}>
                <h2 className="text-2xl font-bold text-white mb-6 flex items-center" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  <span className="w-8 h-8 bg-cyan-500/20 text-cyan-400 rounded-full flex items-center justify-center text-sm mr-3">
                    {catIndex + 1}
                  </span>
                  {category.category}
                </h2>
                
                <Accordion type="single" collapsible className="space-y-4">
                  {category.questions.map((faq, qIndex) => (
                    <AccordionItem 
                      key={qIndex} 
                      value={`${catIndex}-${qIndex}`} 
                      className="glass-effect border-slate-700 rounded-lg px-6"
                      data-testid={`faq-item-${catIndex}-${qIndex}`}
                    >
                      <AccordionTrigger className="text-white font-medium hover:text-cyan-400 text-left">
                        {faq.q}
                      </AccordionTrigger>
                      <AccordionContent>
                        <div className="text-slate-300 text-sm whitespace-pre-line pt-2">
                          {faq.a}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-20 px-6 bg-slate-900/50">
        <div className="container mx-auto">
          <Card className="glass-effect border-slate-700 p-6 sm:p-12 text-center max-w-3xl mx-auto">
            <MessageCircle size={48} className="text-cyan-400 mx-auto mb-6" />
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 break-words" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Masih Ada Pertanyaan?
            </h2>
            <p className="text-slate-300 mb-8 break-words">
              Jangan ragu untuk menghubungi kami. Kami siap membantu menjawab pertanyaan spesifik tentang project atau kebutuhan Anda.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/6281234567890" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
                <Button className="btn-primary text-base px-8 py-6 w-full sm:w-auto" data-testid="faq-whatsapp-cta">
                  Chat via WhatsApp
                </Button>
              </a>
              <Link to="/contact" className="w-full sm:w-auto">
                <Button variant="outline" className="btn-secondary text-base px-8 py-6 w-full sm:w-auto" data-testid="faq-contact-cta">
                  Kirim Pesan
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
}